import store from '@/store'
import routes from '@/route_names'
import DummyComponent from '@/components/DummyComponent.vue'

export default {
  path: 'projects/:projectId/campaigns/:campaignId/survey',
  name: routes.SURVEY,
  component: () =>
    import(/* webpackChunkName: "dashboard" */ './SurveyView.vue'),
  meta: {
    layout: 'dashboard/DashboardLayout',
    requiresAuth: true,
    requiredRole: 'ADMIN',
    defaultChild: routes.SURVEY_METRICS
  },
  beforeEnter: (to, from, next) => {
    next()
  },
  children: [
    {
      path: 'metrics',
      name: routes.SURVEY_METRICS,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './SelectMetricsView.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN'
      }
    },
    {
      path: 'customize',
      name: routes.SURVEY_CUSTOMIZE,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './CustomizeView.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        defaultChild: routes.SURVEY_CUSTOMIZE_NPS
      },
      children: [
        {
          path: 'nps',
          name: routes.SURVEY_CUSTOMIZE_NPS,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ './customize/BaseView.vue'
            ),
          props: () => ({
            tabSettings: {
              preselected: null,
              tabs: [
                {
                  id: routes.SURVEY_CUSTOMIZE_NPS_QUESTION,
                  label: '1. NPS Design'
                },
                {
                  id: routes.SURVEY_CUSTOMIZE_NPS_DRIVERS,
                  label: '2. Drivers'
                },
                {
                  id: routes.SURVEY_CUSTOMIZE_NPS_OPEN_ENDED,
                  label: '3. Open-ended'
                }
              ]
            }
          }),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            defaultChild: routes.SURVEY_CUSTOMIZE_NPS_QUESTION
          },
          children: [
            {
              path: 'nps-design',
              name: routes.SURVEY_CUSTOMIZE_NPS_QUESTION,
              component: DummyComponent,
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN'
              }
            },
            {
              path: 'drivers',
              name: routes.SURVEY_CUSTOMIZE_NPS_DRIVERS,
              component: DummyComponent,
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN'
              }
            },
            {
              path: 'open-ended',
              name: routes.SURVEY_CUSTOMIZE_NPS_OPEN_ENDED,
              component: DummyComponent,
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN'
              }
            }
          ]
        },
        {
          path: 'csat',
          name: routes.SURVEY_CUSTOMIZE_CSAT,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ './customize/BaseView.vue'
            ),
          props: () => ({
            tabSettings: {
              preselected: null,
              tabs: [
                {
                  id: routes.SURVEY_CUSTOMIZE_CSAT_QUESTION,
                  label: '1. CSAT Design'
                },
                {
                  id: routes.SURVEY_CUSTOMIZE_CSAT_DRIVERS,
                  label: '2. Drivers'
                },
                {
                  id: routes.SURVEY_CUSTOMIZE_CSAT_OPEN_ENDED,
                  label: '3. Open-ended'
                }
              ]
            }
          }),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            defaultChild: routes.SURVEY_CUSTOMIZE_CSAT_QUESTION
          },
          children: [
            {
              path: 'csat-design',
              name: routes.SURVEY_CUSTOMIZE_CSAT_QUESTION,
              component: DummyComponent,
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN'
              }
            },
            {
              path: 'drivers',
              name: routes.SURVEY_CUSTOMIZE_CSAT_DRIVERS,
              component: DummyComponent,
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN'
              }
            },
            {
              path: 'open-ended',
              name: routes.SURVEY_CUSTOMIZE_CSAT_OPEN_ENDED,
              component: DummyComponent,
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN'
              }
            }
          ]
        },
        {
          path: 'ces',
          name: routes.SURVEY_CUSTOMIZE_CES,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ './customize/BaseView.vue'
            ),
          props: () => ({
            tabSettings: {
              preselected: null,
              tabs: [
                {
                  id: routes.SURVEY_CUSTOMIZE_CES_QUESTION,
                  label: '1. CES Design'
                },
                {
                  id: routes.SURVEY_CUSTOMIZE_CES_DRIVERS,
                  label: '2. Drivers'
                },
                {
                  id: routes.SURVEY_CUSTOMIZE_CES_OPEN_ENDED,
                  label: '3. Open-ended'
                }
              ]
            }
          }),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            defaultChild: routes.SURVEY_CUSTOMIZE_CES_QUESTION
          },
          children: [
            {
              path: 'ces-design',
              name: routes.SURVEY_CUSTOMIZE_CES_QUESTION,
              component: DummyComponent,
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN'
              }
            },
            {
              path: 'drivers',
              name: routes.SURVEY_CUSTOMIZE_CES_DRIVERS,
              component: DummyComponent,
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN'
              }
            },
            {
              path: 'open-ended',
              name: routes.SURVEY_CUSTOMIZE_CES_OPEN_ENDED,
              component: DummyComponent,
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'appearance',
      name: routes.SURVEY_APPEARANCE,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './AppearanceView.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN'
      }
    },
    {
      path: 'settings',
      name: routes.SURVEY_SETTINGS,
      component: () =>
        import(
          /* webpackChunkName: "dashboard" */ './Settings.vue'
        ),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN'
      }
    },
    {
      path: 'integrations',
      name: routes.SURVEY_INTEGRATIONS,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './IntegrationsView.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN'
      }
    },
    {
      path: 'publish',
      name: routes.SURVEY_PUBLISH,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './PublishView.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN'
      }
    }
  ]
}
